import { Injectable } from '@angular/core';
import { catchError, retry } from 'rxjs/internal/operators';
import { Observable, throwError } from 'rxjs';
import { HttpClientModule, HttpHeaders, HttpClient } from '@angular/common/http';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { CartProduct, Product } from '../classes/orders';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlobalSearchService } from '../services/globalsearchservice.service';

@Injectable({
	providedIn: 'root'
})

export class CreditService {

	key = 'UET6DFMPAXW7BKCB';
	items: Product[] = [];
	config: any;
	user: any = [];
	package: any = '';

	constructor(private http: HttpClient, private _configSvc: RuntimeConfigLoaderService, public globalSearchService: GlobalSearchService) {

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		})
		this.globalSearchService.user.subscribe((result: any) => {
			this.user = result;
		});
	}

	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
		})
	};

	public getDeliveredOrders() {
		const method = 'credits/delivered';
		return this.http.post(this.setEndPoint(method), method, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getOrderStatuses() {
		const method = 'orders/getstatuses';
		return this.http.get(this.setEndPoint(method));
	}

	public updateOrderStatus(data: any) {
		const method = 'credits/updatestatus';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}


	public getRefused() {
		const method = 'oms/dashboard/refused';
		return this.http.post(this.setEndPoint(method), method, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public unflagCart(debtorno: any, branchcode: any) {
		const method = 'credits/cart/unflagcredit&debtorno=' + debtorno + '&branchcode=' + branchcode;
		return this.http.post(this.setEndPoint(method), method, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public flagCart(debtorno: any, branchcode: any) {
		const method = 'credits/cart/flagcredit&debtorno=' + debtorno + '&branchcode=' + branchcode;
		return this.http.post(this.setEndPoint(method), method, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public changeOrderCustomer(customer: any) {
		const method = 'credits/cart/changecustomer';
		return this.http.post(this.setEndPoint(method), customer, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public setSalesOrderPoOptions(data: any) {
		const method = 'credits/cart/updatesalespoitem';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public setDelivered(data: any) {
		const method = 'oms/picking/setdelivered';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public updateOrderToPicked(data: any) {
		const method = 'oms/picking/updatepicked';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public setPoOptions(data: any) {
		const method = 'credits/cart/updatepoitem';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getPurchDataFromLine(data: any) {
		const method = 'credits/cart/poitem';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getPoRequired(data: any) {
		const method = 'credits/cart/poitems';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getItemSearch(data: any) {
		const method = 'credits/items/search';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getSingleItemSearch(data: any) {
		const method = 'credits/items/searchsingle';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getItemFilter(data: any) {
		const method = 'credits/items/search&filter=true';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getCustomer(customerid: any, branchcode: any) {
		const method = 'customers/orderentry&debtorno=' + customerid + '&branchcode=' + branchcode;
		return this.http.get(this.setEndPoint(method));
	}


	public loadCreditFromSalesOrderWTransno(data: any) {
		const method = 'credits/loadsalesorder';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public loadCreditFromSalesOrder(orderno: any) {
		const method = 'credits/loadsalesorder&oid=' + orderno;
		return this.http.get(this.setEndPoint(method));
	}

	public loadRma(orderno: any) {
		const method = 'credits/loadorder&oid=' + orderno;
		return this.http.get(this.setEndPoint(method));
	}

	public loadSalesOrder(orderno: any) {
		const method = 'credits/loadsalesorder&oid=' + orderno;
		return this.http.get(this.setEndPoint(method));
	}

	public cancelQuote(orderno: any) {
		const method = 'credits/quotes/cancel';
		return this.http.post(this.setEndPoint(method), { orderno: orderno }, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}
	/**
	 * Cancel an RMA. The server cancels the inbound at PGS first when the return was
	 * already transmitted; if PGS refuses (it locks an inbound once receiving starts)
	 * nothing is cancelled locally and the response carries pgs_blocked = true.
	 * Pass force = true to cancel in QBC anyway.
	 */
	public cancelOrder(orderno: any, force: boolean = false) {
		const method = 'credits/cancel';
		return this.http.post(this.setEndPoint(method), { orderno: orderno, force: force }, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getTransactionById(id: any) {
		const method = 'credits/gettransaction&id=' + id;
		return this.http.get(this.setEndPoint(method));

	}
	public getQuotes(debtorno: any, branchcode: any) {
		const method = 'credits/getquotes&debtorno=' + debtorno + '&branchcode=' + branchcode;
		return this.http.get(this.setEndPoint(method));
	}


	public saveQuote(customer: any, items: any, totals: any, user: any) {
		const method = 'credits/savequote';
		return this.http.post(this.setEndPoint(method), { customer: customer, items: items }, this.httpOptions).pipe(
			catchError(this.handleError(method, customer))
		);
	}

	public getPick(orderno: any) {
		const url = 'https://cleve.qbcsys.com/PDFPickingListSinglePortrait.php?TransNo=2135133&pre=1&se=1';
	}

	public downloadReport(): Observable < any > {
		// Create url
		this.httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
			}),
		}

		const url = 'https://cleve.qbcsys.com/?route=salesman/documents/picking&key=9NPZ5AJ4FNNT9C7Y&id=2135137';
		const body = { orderno: 2135133 };

		return this.http.post(url, body, {
			responseType: 'blob',
			headers: new HttpHeaders().append('Content-Type', 'application/json')
		});
	}

	public getOrders() {
		const method = 'orders';
		return this.http.get(this.setEndPoint(method));
	}
	public getOrderSearch(keywords: any) {
		const method = 'credits/search&keywords=' + keywords;
		return this.http.get(this.setEndPoint(method));
	}

	public getCustomerOpenOrders(debtorno: any) {
		const method = 'credits&debtorno=' + debtorno;
		return this.http.get(this.setEndPoint(method));
	}

	public getCustomerOpenOrdersByItem(item: any) {
		const method = 'credits&stockid=' + item;
		return this.http.get(this.setEndPoint(method));
	}

	public getTotals(customer: any, branchcode: any, freight: any = 0.00, from_order: any = '', pos: any = false, loccode: any = false) {
		const method = 'credits/cart/gettotals';
		return this.http.post(this.setEndPoint(method), { debtorno: customer, branchcode: branchcode, freight: freight, from_order: from_order, pos: pos, store_loccode: loccode }, this.httpOptions).pipe(
			catchError(this.handleError(method, customer))
		);
	}

	public getDispatches() {
		const method = 'credits/dispatches';
		return this.http.get(this.setEndPoint(method));
	}

	public getOrderInvoice(oid) {
		const method = 'credits/open/invoice&oid=' + oid;
		return this.http.get(this.setEndPoint(method));
	}

	public getOrder(oid, pos: any = false, all: any = false) {
		const method = 'credits/open&oid=' + oid + '&pos=' + pos + '&all=' + all;
		return this.http.get(this.setEndPoint(method));
	}

	public setOrderItems(items) {
		this.items = items;
	}

	public addMultipleToOrder(products: any, customer: string, branchcode: string) {
		const method = 'credits/cart/addmultiple';
		return this.http.post(this.setEndPoint(method), { items: products, customer: customer, branchcode: branchcode }, this.httpOptions).pipe(
			catchError(this.handleError(method, products))
		);
	}


	public addNonStock(data: any) {
		const method = 'credits/cart/addnonstock';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}
	public addToOrder(product: any, customer: string, branchcode: string) {
		this.items.push(product);
		const method = 'credits/cart/add';
		return this.http.post(this.setEndPoint(method), { item: product, customer: customer, branchcode: branchcode }, this.httpOptions).pipe(
			catchError(this.handleError(method, product))
		);
	}


	public updateOrder(product) {
		const method = 'credits/cart/update';
		return this.http.post(this.setEndPoint(method), product, this.httpOptions).pipe(
			catchError(this.handleError(method, product))
		);
	}

	public clearOrder(customerno: any, branchcode: any) {
		this.items = [];
		const method = 'credits/cart/clear';
		return this.http.post(this.setEndPoint(method), { customerno: customerno, branchcode: branchcode }, this.httpOptions).pipe(
			catchError(this.handleError(method, customerno))
		);
	}

	public createInvoice(order: any) {
		const method = 'credits/invoice';
		return this.http.post(this.setEndPoint(method), order, this.httpOptions).pipe(
			catchError(this.handleError(method, order))
		);
	}

	public updateSalesOrder(customer: any, items: any, totals: any, order: any, user: any) {
		const method = 'credits/cart/updateorder';
		return this.http.post(this.setEndPoint(method), { customer: customer, items: items, totals: totals, order: order, user: user }, this.httpOptions).pipe(
			catchError(this.handleError(method, customer))
		);
	}

	public createOrder(customer: any, items: any, totals: any, user: any) {
		const method = 'credits/cart/complete';
		return this.http.post(this.setEndPoint(method), { customer: customer, items: items, totals: totals, user: user }, this.httpOptions).pipe(
			catchError(this.handleError(method, customer))
		);
	}

	public removeFromOrder(cart_id, customer, branchcode: any) {
		const method = 'credits/cart/remove';
		return this.http.post(this.setEndPoint(method), { cart_id: cart_id, customer: customer, branchcode: branchcode }, this.httpOptions).pipe(
			catchError(this.handleError(method, cart_id))
		);
	}

	public getRunPick(column: any) {
		const method = 'oms/runpick&column=' + column;
		return this.http.get(this.setEndPoint(method));
	}

	public getCards() {
		const method = 'oms/cards';
		return this.http.get(this.setEndPoint(method));
	}

	public getPicks() {
		const method = 'oms/picking';
		return this.http.get(this.setEndPoint(method));
	}

	public getOrderItems(search, branchcode: any) {
		const method = 'credits/cart';
		this.getCart(search, branchcode).subscribe((results: Product[]) => {
			this.items = results;
			return results
		});;

		return this.items;
	}

	public getCart(search: any, branchcode: any) {
		const method = 'credits/cart';
		return this.http.post(this.setEndPoint(method), { customerno: search, branchcode: branchcode }, this.httpOptions).pipe(
			catchError(this.handleError(method, search))
		);

	}

	public getStockProducts(search) {
		const method = 'inventory&stock=true';
		return this.http.post(this.setEndPoint(method), search, this.httpOptions).pipe(
			catchError(this.handleError(method, search))
		);
	}

	public getProducts(search) {
		const method = 'inventory';
		return this.http.post(this.setEndPoint(method), search, this.httpOptions).pipe(
			catchError(this.handleError(method, search))
		);
	}


	public getOrderList(oid) {
		const method = 'credits/getdetails&oid=' + oid;
		return this.http.get(this.setEndPoint(method));
	}

	public getPicking() {
		const method = 'oms/fillable';
		return this.http.get(this.setEndPoint(method));
	}

	public setPicking(data) {
		const method = 'credits/pick';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getADRS() {
		const method = 'credits/adrs/pending';
		return this.http.get(this.setEndPoint(method));
	}
	public getADRSReject() {
		const method = 'credits/adrs/rejected';
		return this.http.get(this.setEndPoint(method));
	}
	public printCustomerCredit(orderid){
		const method = 'documents/credits/picking&id=' +orderid + '&base64=true&direct=true';
		return this.http.get(this.setEndPoint(method));
	}

	/**
	 * Send/sync an RMA to PGS. First call creates the inbound; once it exists at PGS the
	 * same endpoint pushes the current lines via update (PUT), so edits sync — no separate
	 * "amend" call needed. forceResend is retained for callers that want an explicit re-push.
	 */
	public sendRmaToPgs(orderno: string, forceResend = false): Observable<{ success: boolean; message?: string; cached?: boolean; [key: string]: any }> {
		const method = 'credits/sendtopgs';
		const body: any = { orderno };
		if (forceResend) { body.forceResend = true; }
		return this.http.post<any>(this.setEndPoint(method), body, this.httpOptions).pipe(
			catchError(this.handleError(method, body))
		);
	}

	private setEndPoint(method: any) {
		return this.getApi() + method + this.getApiKey()
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {
		return '&key=' + this.config.apiCredentials.clientId + '&userid=' + this.user.user.userid + this.getPackage();
	}

	private getPackage() {
		const p = this.globalSearchService.getSessionItem('package');
		if(p) {
			return '&package='+p;
		} else {
			return '';
		}
	}

	public getKey() {
		return '&apikey=' + this.key;
	}

	private handleError<T>(operation = 'operation', result?: T) {

		return (error: any): Observable<T> => {

			if (error instanceof HttpErrorResponse && error.status === 401) {
				window.location.href = '/#/auth/logout';
			}

			return throwError(() => error);
		};
	}

}
